import { render, staticRenderFns } from "./RestaurantsCategoryImageIssues.vue?vue&type=template&id=50d61d19&scoped=true"
import script from "./RestaurantsCategoryImageIssues.vue?vue&type=script&lang=js"
export * from "./RestaurantsCategoryImageIssues.vue?vue&type=script&lang=js"
import style0 from "./RestaurantsCategoryImageIssues.vue?vue&type=style&index=0&id=50d61d19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d61d19",
  null
  
)

export default component.exports